import { useSearchParams } from 'react-router-dom';
import useStyles from './styles';
import Loader from '../Loader';
import { Box } from '@mui/system';
import Sidebar from './Sidebar';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

const getFirstSettingName = (sidebarConfig) => {
	for (let i = 0; i < sidebarConfig.length; i++) {
		if (sidebarConfig[i].isButton) {
			continue;
		}
		if (sidebarConfig[i].isAccordion) {
			const settingNameWithinAccordion = getFirstSettingName(sidebarConfig[i].settings);
			if (settingNameWithinAccordion) {
				return settingNameWithinAccordion;
			}
		}
		return sidebarConfig[i].settingName;
	}

	return null;
};

const ConfigEditorMainPage = ({
	sidebarConfig,
	settingConfigs,
	system = SYSTEMS.FRAMERATE,
	isLoading = true
}) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const defaultSetting = getFirstSettingName(sidebarConfig);
	const tabFromUrl = searchParams.get('tab');

	// Use URL param if it maps to a valid config, otherwise fall back to default
	const settingName =
		tabFromUrl && settingConfigs[tabFromUrl] ? tabFromUrl : defaultSetting;

	const classes = useStyles();

	const changeSetting = (newSettingName) => {
		setSearchParams({ tab: newSettingName });
	}

	return (
		<Box className={classes.configEditor}>
			{!isLoading && (
				<>
					<Sidebar
						sidebarConfig={sidebarConfig}
						changeSetting={changeSetting}
						currentSetting={settingName}
						system={system}
					/>
					<Box className={classes.settingConfig}>{settingConfigs[settingName]}</Box>
				</>
			)}
			{isLoading && <Loader />}
		</Box>
	);
};
export default ConfigEditorMainPage;
